import React from "react";

import { OverflowTooltip } from "components";
import { Application, TableCellProp } from "types";

const merchantStatusColumn = () => ({
	Header: "Merchant Status",
	accessor: "applicationMerchantStatus",
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		return (
			<OverflowTooltip onlyOnLaptop title={original?.merchant_status}>
				{original?.merchant_status}
			</OverflowTooltip>
		);
	},
});

export default merchantStatusColumn;
